import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Chrome and Edge offer installing once per page load; keep the offer for the CRM settings button.
window.addEventListener('beforeinstallprompt', (event) => {
  event.preventDefault();
  (window as unknown as { __installPrompt?: Event }).__installPrompt = event;
});

// Installable app and incoming-call notifications (public/sw.js). Not inside the desktop app's webview.
if ('serviceWorker' in navigator && import.meta.env.PROD && !('__TAURI_INTERNALS__' in window)) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => console.warn('Service worker not registered:', error));
  });
}
